import { Redirect } from 'react-router-dom';

export default function Home() {
  return <Redirect to="/login" />;
}
